export const GOOGLE_AD_MANAGER_AD_ACCOUNT = 'gam_ad_account'

export const ALLOCATION_TYPE = 'allocation_type'

export const IS_SUB_ALLOCATION = 'is_sub_allocation'

export const INVENTORY_TYPE = 'inventoryType'
export const INVENTORY_TYPE_AD_PLACEMENTS = 'ad_placements'
export const INVENTORY_TYPE_AD_UNITS = 'ad_units'
export const AD_INVENTORY = 'ad_inventory'

export const SUB_ALLOCATION = 'sub_allocation'

export const PLACEMENT_ID = 'placement_id'
export const AD_UNIT_ID = 'ad_unit_id'
export const AD_PLACEMENTS = 'ad_placements'
export const AD_UNITS = 'ad_units'

export const ADVANCED_SETTINGS = 'advanced_settings'
export const SKIPPABLE_ADS_ENABLED = 'skippable_ads_enabled'
export const AD_INVENTORY_TARGETING_ENABLED = 'ad_inventory_targeting_enabled'
export const GEO_TARGETING_ENABLED = 'geo_targeting_enabled'
export const DEVICE_TARGETING_ENABLED = 'device_targeting_enabled'
export const CUSTOM_TARGETING_ENABLED = 'custom_targeting_enabled'

export const BILLING_EVENT = 'billing_event'

export const TOTAL_VALUE = 'total_value'

export const allocationTypes = {
  impressions: 'impressions',
  clicks: 'clicks',
  viewable_impressions: 'viewable_impressions',
  impressions_sponsorship: 'impressions_sponsorship',
  budget: 'budget'
}

export const allocationTypeOptions = [
  {
    value: allocationTypes.impressions,
    label: 'Impressions (Quantity)'
  },
  {
    value: allocationTypes.clicks,
    label: 'Clicks (Quantity)'
  },
  {
    value: allocationTypes.viewable_impressions,
    label: 'Viewable impressions (Quantity)'
  },
  {
    value: allocationTypes.impressions_sponsorship,
    label: 'Impressions (Sponsorship)'
  },
  {
    value: allocationTypes.budget,
    label: 'Budget'
  }
]

export const billingEventOptions = [
  {
    value: allocationTypes.impressions,
    label: 'Impressions'
  },
  {
    value: allocationTypes.clicks,
    label: 'Clicks'
  },
  {
    value: allocationTypes.viewable_impressions,
    label: 'Viewable impressions'
  }
]

export const allocationTypeLabels = {
  impressions: 'impressions',
  clicks: 'clicks',
  viewable_impressions: 'viewable impressions',
  impressions_sponsorship: 'impressions sponsorship'
}

export const rightTypes = {
  percentage: 'percentage',
  quantity: 'quantity',
  budget:
    // can't name this field 'budget' because it conflicts with formik initialValues 'budget' field
    'budgetAllocation'
}

export const allocationGroups = {
  impressions: rightTypes.quantity,
  clicks: rightTypes.quantity,
  viewable_impressions: rightTypes.quantity,
  impressions_sponsorship: rightTypes.percentage,
  budget: rightTypes.budget
}

export const interchangeableAllocationTypes = {
  impressions: 'cpm',
  clicks: 'cpc',
  viewable_impressions: 'viewable_cpm',
  impressions_sponsorship: 'cpm',
  budget: ''
}

export const inventoryTypeOptions = [
  {
    value: INVENTORY_TYPE_AD_PLACEMENTS,
    label: 'Placements'
  },
  {
    value: INVENTORY_TYPE_AD_UNITS,
    label: 'Ad units'
  }
]
